import axios from "axios";
import config from "services/config";

const BASE = `${config.url}/payroll`;

function adminHeaders() {
  return { Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}` };
}

export const PayrollService = {
  // ─── Empleados ─────────────────────────────────────────────
  async listEmployees(memberId, { status } = {}) {
    const { data } = await axios.get(`${BASE}/employees/${memberId}`, { params: { status }, headers: adminHeaders() });
    return data;
  },
  async createEmployee(memberId, payload) {
    const { data } = await axios.post(`${BASE}/employees/${memberId}`, payload, { headers: adminHeaders() });
    return data;
  },
  async updateEmployee(memberId, id, payload) {
    const { data } = await axios.patch(`${BASE}/employees/${memberId}/${id}`, payload, { headers: adminHeaders() });
    return data;
  },
  async deleteEmployee(memberId, id) {
    const { data } = await axios.delete(`${BASE}/employees/${memberId}/${id}`, { headers: adminHeaders() });
    return data;
  },

  // ─── Contratos ─────────────────────────────────────────────
  async listContracts(memberId, { employee, status } = {}) {
    const { data } = await axios.get(`${BASE}/contracts/${memberId}`, { params: { employee, status }, headers: adminHeaders() });
    return data;
  },
  async createContract(memberId, payload) {
    const { data } = await axios.post(`${BASE}/contracts/${memberId}`, payload, { headers: adminHeaders() });
    return data;
  },
  async updateContract(memberId, id, payload) {
    const { data } = await axios.patch(`${BASE}/contracts/${memberId}/${id}`, payload, { headers: adminHeaders() });
    return data;
  },
  async deleteContract(memberId, id) {
    const { data } = await axios.delete(`${BASE}/contracts/${memberId}/${id}`, { headers: adminHeaders() });
    return data;
  },

  // ─── Corridas ──────────────────────────────────────────────
  async listRuns(memberId, { year, month, status } = {}) {
    const { data } = await axios.get(`${BASE}/runs/${memberId}`, { params: { year, month, status }, headers: adminHeaders() });
    return data;
  },
  async runCalculate(memberId, { year, month }) {
    const { data } = await axios.post(`${BASE}/runs/${memberId}`, { year, month }, { headers: adminHeaders() });
    return data;
  },
  async preview(memberId, { year, month }) {
    const { data } = await axios.post(`${BASE}/runs/${memberId}/preview`, { year, month }, { headers: adminHeaders() });
    return data;
  },
  async getRun(runId) {
    const { data } = await axios.get(`${BASE}/runs/by-id/${runId}`, { headers: adminHeaders() });
    return data;
  },
  async approveRun(runId) {
    const { data } = await axios.post(`${BASE}/runs/by-id/${runId}/approve`, {}, { headers: adminHeaders() });
    return data;
  },
  async markRunPaid(runId) {
    const { data } = await axios.post(`${BASE}/runs/by-id/${runId}/paid`, {}, { headers: adminHeaders() });
    return data;
  },
  async downloadPrevired(runId, period) {
    const response = await axios.get(`${BASE}/runs/by-id/${runId}/previred`, {
      headers: adminHeaders(),
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "text/plain;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `previred_${period.year}${String(period.month).padStart(2, "0")}.txt`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  },
};
